import { useContext, useRef, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Cases, DELETE_CONFIRM, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import { Zoom, toast } from "react-toastify";
import {
  getAboutUs,
  postAboutUs,
  putUpdateAboutUs,
} from "../apis/AboutApi/AboutUsApi";
import { FILE_TYPE, ThemeNo, titleUpdateKey } from "../../../../constant";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import SimpleReactValidator from "simple-react-validator";
import ReportDownloadSentParentPopup from "./ReportDownloadSentParentPopup";
import { IconButton } from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import { Settings, Trash } from "react-feather";
import ReportDownloadSentSettingParent from "./ReportDownloadSentSettingParent";
import {
  addUrlImage,
  convertRGBA,
  isCheckValue,
  isEmptyObject,
  randomStr,
  removeUrlImage,
  removeUrlKeyInPath,
  rgbColorCreate,
} from "../../../../utils/helper";
import { FILE_UPLOAD_API } from "../apis/SliderApi/SliderApi";
import DeleteSection from "../../../common/DeleteSection";
import SettingMultiWebContext from "../../../../context/SettingMultiWebContext/SettingMultiWebContext";
import { reportDownloadSentStyleFunctiontyleOneReset } from "./ReportDownloadSentStyleFunction";
import ReportDownloadSentContext from "../../../context/ReportDownloadSentContext/ReportDownloadSentContext";
import {
  deleteDownloadSendReports,
  getDownloadSendReportsDetails,
  postDownloadSendReports,
  putUpdateDownloadSendReports,
  updateStatusDownloadSendReports,
} from "../apis/ReportDownloadSentApi/ReportDownloadSentApi";
import ReportDownloadSentPopup from "./reportDownloadSentPopup";
import { uploadFileToSpaces } from "../../../apis/dashboardAPi/DeshboardApi";

const ReportDownloadSent = (props) => {
  const {
    pageConfigDetails,
    webMasterDetail,
    ByteMiniWeb_Dashboard,
    getData,
    downloadSendReportDetail,
    contentMapId,
    contentDetail,
  } = props;

  const { setLoaderShow } = useContext(LoaderContext);
  const { allPopupState, setAllPopupState } = useContext(
    ByteCardBuilderContext
  );
  const { setCloneAlignModal, setAlignFormData, setCloneFormData } = useContext(
    SettingMultiWebContext
  );
  const parentValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const childValidator = useRef(new SimpleReactValidator());
  const {
    apiData: abutUsData,
    setApiData,
    fromData,
    setFormData,
    id,
    setId,
    setIsEdit,
    isEdit,
    formDataParent,
    setFormDataParent,
    settingFormData,
    setSettingFormData,
    childId,
    setChildId,
    theme,
    setTheme,
    setBoxSection,
    setBackImageToggle,
    boxSection,
    collId,
    setCollId,
    isParent,
    setIsParent,
    isBackgroundColor,
    setIsBackgroundColor,
    setImgShow,
    sectionPageName,
    setSectionPageName,
    storeIndex,
    isArrayImg,
    isSingleImg,
  } = useContext(ReportDownloadSentContext);

  const getAboutUsList = async ({
    parentId = null,
    isClose = false,
    filter,
    sectionTitle,
  }) => {
    try {
      let paramObj = { search: { showAll: true } };
      if (
        ((parentId && parentId !== null) ||
          (id && isClose === false && isParent === false)) &&
        isParent === false
      ) {
        paramObj["search"] = { parentId: parentId || id };
        setId(parentId || id);
        if (filter?.length) {
          paramObj["search"] = { ...paramObj.search, title: filter };
        }
      } else {
        paramObj["search"] = { parentId: null };
      }
      const { data } = await getAboutUs(paramObj);
      if (isCheckValue({ value: parentId })) {
        setChildId(parentId);
      }
      if (data.status === 200) {
        if (
          isParent === false &&
          ((parentId && parentId !== null) || id) &&
          isClose === false
        ) {
          setApiData({
            ...abutUsData,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.id,
                Id: elem?.id,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                parentId: elem?.parentId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
          setSectionPageName(sectionTitle);
          OpenModalCommonFunc(Cases.REPORT_DOWN, setAllPopupState);
        } else if (parentId && parentId !== null) {
          setSectionPageName(sectionTitle);
          OpenModalCommonFunc(Cases.REPORT_DOWN, setAllPopupState);
          setApiData({
            ...abutUsData,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.ourClientId,
                Id: elem?.ourClientId,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                parentId: elem?.parentId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
        } else {
          setApiData({
            ...abutUsData,
            isLoading: false,
            data: data.payload.data,
          });
        }
        if (isClose && isClose !== false) {
          setIsParent(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * enable disable api call
   * @param {slider id} sliderId
   * @param {status} isActive
   */

  const handleChangeStatus = async (id, isActive, isChild, parentId) => {
    try {
      let body = {
        reportDownloadSentId: id,
        isActive: isActive ? false : true,
        parentId,
      };
      const { data } = await updateStatusDownloadSendReports(body);
      if (data.status === 200) {
        if (isChild) {
          getAboutUsList({ parentId: parentId });
        } else {
          ByteMiniWeb_Dashboard();
        }
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * image upload
   * @param {file} file
   */
  const imageUpload = async (file) => {
    setLoaderShow(true);
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.REPORT_DOWN);
    // formData.append("file", file);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.REPORT_DOWN,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        if (isArrayImg) {
          let old = [...fromData.otherData];
          delete fromData.image;
          old[storeIndex]["image"] =
            data.payload.baseUrl + data.payload.imageUrl;

          setFormData((prev) => {
            return {
              ...prev,
              otherData: old,
            };
          });
        } else if (isSingleImg) {
          delete fromData.image;
          setFormData((prev) => {
            return {
              ...prev,
              images: data.payload.baseUrl + data.payload.imageUrl,
            };
          });
        }

        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * bhackground image upload
   * @param {file} file
   */
  const backgroundImageUpload = async (file) => {
    setLoaderShow(true);
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.ABOUT_US);
    // formData.append("file", file);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.ABOUT_US,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setSettingFormData((prev) => {
          if (+theme === ThemeNo.ThemeOne) {
            return {
              ...prev,
              ".downloadbox-section.bg-image": {
                "background-image":
                  data.payload.baseUrl + data.payload.imageUrl,
              },
            };
          }
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };
  /**
   * create and update about us
   */
  const handleSubmit = async () => {
    let newData = {};
    if ((childId >= -1 && isEdit) || (id >= -1 && isEdit)) {
      try {
        newData = {
          ...fromData,
          contentMapId: collId,
          id: childId,
        };
        if (fromData?.images?.length) {
          newData["image"] = fromData.images
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
        }
        delete newData?.images;
        setLoaderShow(true);
        const { data } = await putUpdateAboutUs(newData);
        if (data.status === 200) {
          getAboutUsList({ parentId: id });
          TostMessage({ message: data, type: "success" });
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          hanldenewCreate();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let newData = {
          ...fromData,
          contentMapId: collId,
          parentId: id,
        };
        if (fromData?.images?.length) {
          newData["image"] = fromData.images
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
        }
        delete newData?.images;
        const { data } = await postAboutUs(newData);
        if (data.status === 200) {
          getAboutUsList({ parentId: id });
          TostMessage({ message: data, type: "success" });
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          emptyDataReportDownload();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  const handleSubmitSetting = async () => {
    debugger;
    if (id >= -1 && isEdit) {
      try {
        setLoaderShow(true);
        let newData = {
          ...formDataParent,
          contentMapId: collId || contentMapId,
          id: id,
        };
        delete newData.style;
        const { data } = await putUpdateDownloadSendReports(newData);
        if (data.status === 200) {
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
          OpenModalCommonFunc(
            Cases.REPORT_DOWN_PARENT,
            setAllPopupState,
            false
          );
          emptyDataReportDownload();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let newData = {
          ...formDataParent,
          wpNumber: 1,
          contentMapId: collId || contentMapId,
        };
        // delete newData.style;
        const { data } = await postDownloadSendReports(newData);
        if (data.status === 200) {
          ByteMiniWeb_Dashboard();
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
          OpenModalCommonFunc(
            Cases.REPORT_DOWN_PARENT,
            setAllPopupState,
            false
          );
          emptyDataReportDownload();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  const handleSubmitWithValidate = async (formValidationCondition) => {
    let validatorFields;
    if (formValidationCondition === "parentForm") {
      validatorFields = parentValidator.current;
    } else if (formValidationCondition === "childForm") {
      validatorFields = childValidator.current;
    }
    validatorFields.showMessages();

    if (validatorFields.allValid()) {
      try {
        // Process form data based on the formType
        if (formValidationCondition === "parentForm") {
          handleSubmitSetting();
        } else if (formValidationCondition === "childForm") {
          handleSubmit();
        }
        validatorFields.hideMessages();
      } catch (error) {
        // Handle error for form submission
      }
    } else {
      // Force update to display validation messages
      forceUpdate({});
    }
  };

  const handleChangeSettings = async (
    reportDownloadSentId,
    isThemeEdit = false
  ) => {
    try {
      setLoaderShow(true);
      setId(reportDownloadSentId);
      setSettingFormData((prev) => {
        return {
          ...prev,
          reportDownloadSentId,
        };
      });
      const { data } = await getDownloadSendReportsDetails(
        reportDownloadSentId
      );
      if (data.status === 200) {
        const themeCount = data?.payload?.data?.theme;
        console.log("themeCount >> ", themeCount);

        let payload = data.payload.data;
        setSectionPageName(payload?.title);
        setTheme(themeCount);
        setImgShow(true);
        let find = [".downloadbox-section"];
        let section = Object.keys(payload.style);
        let foundItem = null;
        for (const key in find) {
          if (section.includes(find[key])) {
            foundItem = find[key];
            break; // If found, exit the loop
          }
        }
        if (
          +themeCount === ThemeNo.ThemeOne &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({
            ...reportDownloadSentStyleFunctiontyleOneReset,
          });
          setBoxSection(false);
          setBackImageToggle(false);
          setIsBackgroundColor(false);
        } else {
          if (
            payload.style?.[foundItem]?.["width"] ||
            payload.style?.[foundItem]?.["margin"] ||
            payload.style?.[foundItem]?.["border-radius"]
          ) {
            setBoxSection(true);
          }
          if (payload.style?.[`${foundItem}.bg-image`]?.["background-image"]) {
            setBackImageToggle(true);
          }
          if (payload.style?.[`${foundItem}`]?.["background-color"]) {
            setIsBackgroundColor(true);
          }
          setSettingFormData((prev) => {
            return {
              ...prev,
              ...payload.style,
              [foundItem]: {
                padding: payload.style?.[foundItem]?.["padding"],
                "background-color": payload.style?.[foundItem]?.[
                  "background-color"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[foundItem]?.["background-color"],
                  })
                  : "",
                width: payload.style?.[foundItem]?.["width"]?.replace(
                  "calc(100% - ",
                  ""
                ),
                margin: payload.style?.[foundItem]?.["margin"],
                "border-radius": payload.style?.[foundItem]?.["border-radius"],
              },
              [`${foundItem}.bg-image`]: {
                "background-image":
                  payload.style?.[`${foundItem}.bg-image`]?.[
                    "background-image"
                  ] !== "" &&
                    payload.style?.[`${foundItem}.bg-image`]?.[
                    "background-image"
                    ] !== null
                    ? removeUrlKeyInPath({
                      urlString:
                        payload.style?.[`${foundItem}.bg-image`]?.[
                        "background-image"
                        ],
                    })
                    : "",
              },
              [`${foundItem}.bg-image::before`]: {
                "background-color": payload.style?.[
                  `${foundItem}.bg-image::before`
                ]?.["background-color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem}.bg-image::before`]?.[
                      "background-color"
                      ],
                  })
                  : "",
              },
              [`${foundItem} .section-title-area .section-subtitle`]: {
                ...payload.style?.[
                `${foundItem} .section-title-area .section-subtitle`
                ],
                "background-color": payload.style?.[
                  `${foundItem} .section-title-area .section-subtitle`
                ]?.["background-color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .section-title-area .section-subtitle`
                      ]?.["background-color"],
                  })
                  : "",
                color: payload.style?.[
                  `${foundItem} .section-title-area .section-subtitle`
                ]?.["color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .section-title-area .section-subtitle`
                      ]?.["color"],
                  })
                  : "",
              },
              [`${foundItem} .section-title-area .section-title`]: {
                ...payload.style?.[
                `${foundItem} .section-title-area .section-title`
                ],
                color: payload.style?.[
                  `${foundItem} .section-title-area .section-title`
                ]?.["color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .section-title-area .section-title`
                      ]?.["color"],
                  })
                  : "",
              },
              [`${foundItem} .downloadbox`]: {
                ...payload.style?.[`${foundItem} .downloadbox`],
                "background-color": payload.style?.[
                  `${foundItem} .downloadbox`
                ]?.["background-color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .downloadbox`]?.[
                      "background-color"
                      ],
                  })
                  : "",
                borderColor: payload.style?.[`${foundItem} .downloadbox`]?.[
                  "borderColor"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .downloadbox`]?.[
                      "borderColor"
                      ],
                  })
                  : "",
                borderTColor: payload.style?.[`${foundItem} .downloadbox`]?.[
                  "borderTColor"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .downloadbox`]?.[
                      "borderTColor"
                      ],
                  })
                  : "",
                shedowColor: payload.style?.[`${foundItem} .downloadbox`]?.[
                  "shedowColor"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .downloadbox`]?.[
                      "shedowColor"
                      ],
                  })
                  : "",
              },
              [`${foundItem} .downloadbox .form-control`]: {
                ...payload.style?.[`${foundItem} .downloadbox .form-control`],
                "background-color": payload.style?.[
                  `${foundItem} .downloadbox .form-control`
                ]?.["background-color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .downloadbox .form-control`
                      ]?.["background-color"],
                  })
                  : "",
                borderColor: payload.style?.[
                  `${foundItem} .downloadbox .form-control`
                ]?.["borderColor"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[
                      `${foundItem} .downloadbox .form-control`
                      ]?.["borderColor"],
                  })
                  : "",
              },
              [`${foundItem} .downloadbox .btn`]: {
                ...payload.style?.[`${foundItem} .downloadbox .btn`],
                color: payload.style?.[`${foundItem} .downloadbox .btn`]?.[
                  "color"
                ]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .downloadbox .btn`]?.[
                      "color"
                      ],
                  })
                  : "",
                "background-color": payload.style?.[
                  `${foundItem} .downloadbox .btn`
                ]?.["background-color"]
                  ? convertRGBA({
                    rgbString:
                      payload.style?.[`${foundItem} .downloadbox .btn`]?.[
                      "background-color"
                      ],
                  })
                  : "",
              },

              custom: payload?.style?.custom,
            };
          });
        }

        if (!isThemeEdit) {
          OpenModalCommonFunc(
            Cases.SETTING_REPORT_DOWN_PARENT,
            setAllPopupState
          );
          TostMessage({ message: data, type: "success" });
        }

        setIsEdit(true);
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * get details about us
   * @param {id} id
   */
  const handleEdit = async (idAbout, isParent) => {
    try {
      setLoaderShow(true);

      setIsParent(true);
      const { data } = await getDownloadSendReportsDetails(idAbout);

      if (data.status === 200) {
        let payload = data.payload.data;
        if (isParent && isParent !== false) {
          setId(idAbout);
          setSectionPageName(payload?.title);
          setFormDataParent({
            name: payload?.name,
            wpNumber: payload?.wpNumber,
            email: payload?.email,
            contentMapId: payload?.contentMapId,
          });
          setIsEdit(true);
          OpenModalCommonFunc(Cases.REPORT_DOWN_PARENT, setAllPopupState);
        } else {
          setChildId(idAbout);
          setIsParent(false);
          setFormData({
            title: payload.title,
            aboutUs: payload.aboutUs,
            order: payload.order,
            images: payload.image,
            isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
            subTitle: payload.subTitle,
            theme: payload.theme,
            buttonText: payload.buttonText,
            buttonLink: payload.buttonLink,
            imageAlt: payload.imageAlt,
            parentId: payload.parentId,
            otherData: payload?.otherData || [
              {
                id: randomStr(2),
                image: "",
                title: "",
                imageAlt: "",
                description: "",
              },
            ],
          });
          setIsEdit(true);
          setChildId(payload.id);
        }

        TostMessage({ message: data, type: "success" });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * delete images
   * @param {id} reportDownloadSentId
   */
  const handleDelete = async (reportDownloadSentId) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await deleteDownloadSendReports(reportDownloadSentId);
        if (data.status === 200) {
          ByteMiniWeb_Dashboard();
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  const handleAboutUsSubmitSetting = async (
    isRestore = false,
    isClose = true
  ) => {
    if (id >= -1 && isEdit) {
      setLoaderShow(true);
      try {
        let newData;
        if (isRestore) {
          const isConfirm = window.confirm(
            "Are you sure want to restore style ?"
          );
          if (isConfirm) {
            newData = {
              styleRestore: true,
              id: id,
            };
          } else {
            setLoaderShow(false);
            return;
          }
        } else {
          if (+theme === ThemeNo.ThemeOne) {
            newData = {
              ...settingFormData,
              ".downloadbox-section": boxSection
                ? {
                  ...settingFormData?.[".downloadbox-section"],
                  padding: `${settingFormData?.[".downloadbox-section"]?.[
                    "padding"
                  ]
                    ?.split(" ")[0]
                    ?.replace("px", "")}px 0`,
                  width: `calc(100% - ${settingFormData?.[
                    ".downloadbox-section"
                  ]?.["width"]?.replace("rem)", "")}rem)`,
                  margin: `${settingFormData?.[".downloadbox-section"]?.[
                    "margin"
                  ]
                    ?.split(" ")[0]
                    ?.replace("px", "")}px auto`,
                  "border-radius": `${settingFormData?.[
                    ".downloadbox-section"
                  ]?.["border-radius"]?.replace("rem", "")}rem`,
                }
                : {
                  ...settingFormData?.[".downloadbox-section"],
                  padding: `${settingFormData?.[".downloadbox-section"]?.[
                    "padding"
                  ]
                    ?.split(" ")[0]
                    ?.replace("px", "")}px 0`,
                },
              ".downloadbox-section.bg-image": settingFormData?.[
                ".downloadbox-section.bg-image"
              ]?.["background-image"]
                ? {
                  "background-image": settingFormData?.[
                    ".downloadbox-section.bg-image"
                  ]?.["background-image"]
                    ? addUrlImage({
                      urlString: removeUrlImage({
                        urlString:
                          settingFormData?.[
                          ".downloadbox-section.bg-image"
                          ]?.["background-image"],
                      }),
                    })
                    : "",
                }
                : {},
              ".downloadbox-section.bg-image::before": settingFormData?.[
                ".downloadbox-section.bg-image::before"
              ]?.["background-color"]
                ? {
                  "background-color": settingFormData?.[
                    ".downloadbox-section.bg-image::before"
                  ]?.["background-color"]
                    ? rgbColorCreate({
                      rgbString:
                        settingFormData?.[
                        ".downloadbox-section.bg-image::before"
                        ]?.["background-color"],
                    })
                    : "",
                }
                : {},
              ".downloadbox-section .section-title-area": {
                "margin-bottom": `${settingFormData[
                  ".downloadbox-section .section-title-area"
                ]?.["margin-bottom"]?.replace("px", "")}px`,
              },
              ".downloadbox-section .section-title-area .section-subtitle": {
                ...settingFormData?.[
                ".downloadbox-section .section-title-area .section-subtitle"
                ],
                "font-size": `${settingFormData?.[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["font-size"]?.replace("px", "")}px`,
                "font-weight": `${settingFormData?.[".downloadbox-section .section-title-area .section-subtitle"]?.["font-weight"]}`,
                color: settingFormData?.[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .section-title-area .section-subtitle"
                      ]?.["color"],
                  })
                  : "",
                "background-color": settingFormData?.[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["background-color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .section-title-area .section-subtitle"
                      ]?.["background-color"],
                  })
                  : "",
                padding: `${settingFormData?.[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["p1"]?.replace("px", "")}px ${settingFormData[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["p2"]?.replace("px", "")}px`,
                p1: `${settingFormData?.[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["p1"]?.replace("px", "")}px`,
                p2: `${settingFormData?.[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["p2"]?.replace("px", "")}px`,
                "border-radius": `${settingFormData?.[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["border-radius"]?.replace("px", "")}px`,
                "margin-bottom": `${settingFormData[
                  ".downloadbox-section .section-title-area .section-subtitle"
                ]?.["margin-bottom"]?.replace("px", "")}px`,
              },
              ".downloadbox-section .section-title-area .section-title": {
                ...settingFormData?.[".section-title-area .section-title"],
                "font-size": `${settingFormData?.[
                  ".downloadbox-section .section-title-area .section-title"
                ]?.["font-size"]?.replace("px", "")}px`,
                "font-weight": `${settingFormData?.[".downloadbox-section .section-title-area .section-title"]?.["font-weight"]}`,
                color: settingFormData?.[
                  ".downloadbox-section .section-title-area .section-title"
                ]?.["color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .section-title-area .section-title"
                      ]?.["color"],
                  })
                  : "",
              },
              ".downloadbox-section .downloadbox": {
                ...settingFormData?.[".downloadbox-section .downloadbox"],
                "background-color": settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["background-color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox"
                      ]?.["background-color"],
                  })
                  : "",
                padding: `${settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["p1"]?.replace("px", "")}px ${settingFormData[
                  ".downloadbox-section .downloadbox"
                ]?.["p2"]?.replace("px", "")}px`,
                p1: `${settingFormData?.[".downloadbox-section .downloadbox"]?.[
                  "p1"
                ]?.replace("px", "")}px`,
                p2: `${settingFormData?.[".downloadbox-section .downloadbox"]?.[
                  "p2"
                ]?.replace("px", "")}px`,
                "border-radius": `${settingFormData[
                  ".downloadbox-section .downloadbox"
                ]?.["border-radius"]?.replace("px", "")}px`,
                border: `${settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["borderPx"]?.replace("px", "")}px ${settingFormData?.[".downloadbox-section .downloadbox"][
                "borderThik"
                ]
                  } ${rgbColorCreate({
                    rgbString:
                      settingFormData?.[".downloadbox-section .downloadbox"]?.[
                      "borderColor"
                      ],
                  })}`,
                borderPx: `${settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["borderPx"]?.replace("px", "")}px`,
                borderThik: `${settingFormData?.[".downloadbox-section .downloadbox"]?.["borderThik"]}`,
                borderColor: settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["borderColor"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox"
                      ]?.["borderColor"],
                  })
                  : "",
                "border-top": `${settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["borderTPx"]?.replace("px", "")}px ${settingFormData?.[".downloadbox-section .downloadbox"][
                "borderTThik"
                ]
                  } ${rgbColorCreate({
                    rgbString:
                      settingFormData?.[".downloadbox-section .downloadbox"]?.[
                      "borderTColor"
                      ],
                  })}`,
                borderTPx: `${settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["borderTPx"]?.replace("px", "")}px`,
                borderTThik: `${settingFormData?.[".downloadbox-section .downloadbox"]?.["borderTThik"]}`,
                borderTColor: settingFormData?.[
                  ".downloadbox-section .downloadbox"
                ]?.["borderTColor"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox"
                      ]?.["borderTColor"],
                  })
                  : "",
                "box-shadow": `${settingFormData[
                  ".downloadbox-section .downloadbox"
                ]["bs1"]?.replace("px", "")}px ${settingFormData[
                  ".downloadbox-section .downloadbox"
                ]["bs2"]?.replace("px", "")}px ${settingFormData[
                  ".downloadbox-section .downloadbox"
                ]["bs3"]?.replace("px", "")}px ${rgbColorCreate({
                  rgbString:
                    settingFormData[".downloadbox-section .downloadbox"]?.[
                    "shadowColor"
                    ],
                })}`,
              },
              ".downloadbox-section .downloadbox .form-control": {
                ...settingFormData?.[
                ".downloadbox-section .downloadbox .form-control"
                ],
                width: `${settingFormData?.[
                  ".downloadbox-section .downloadbox .form-control"
                ]?.["width"]?.replace("%", "")}%`,
                "margin-bottom": `${settingFormData?.[
                  ".downloadbox-section .downloadbox .form-control"
                ]?.["margin-bottom"]?.replace("px", "")}px`,
                "background-color": settingFormData?.[
                  ".downloadbox-section .downloadbox .form-control"
                ]?.["background-color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox .form-control"
                      ]?.["background-color"],
                  })
                  : "",
                border: `${settingFormData?.[
                  ".downloadbox-section .downloadbox .form-control"
                ]?.["borderPx"]?.replace("px", "")}px ${settingFormData?.[
                ".downloadbox-section .downloadbox .form-control"
                ]["borderThik"]
                  } ${rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox .form-control"
                      ]?.["borderColor"],
                  })}`,
                borderPx: `${settingFormData?.[
                  ".downloadbox-section .downloadbox .form-control"
                ]?.["borderPx"]?.replace("px", "")}px`,
                borderThik: `${settingFormData?.[".downloadbox-section .downloadbox .form-control"]?.["borderThik"]}`,
                borderColor: settingFormData?.[
                  ".downloadbox-section .downloadbox .form-control"
                ]?.["borderColor"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox .form-control"
                      ]?.["borderColor"],
                  })
                  : "",
                "font-size": `${settingFormData?.[
                  ".downloadbox-section .downloadbox .form-control"
                ]?.["font-size"]?.replace("px", "")}px`,
              },
              ".downloadbox-section .downloadbox .btn": {
                "background-color": settingFormData?.[
                  ".downloadbox-section .downloadbox .btn"
                ]?.["background-color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox .btn"
                      ]?.["background-color"],
                  })
                  : "",
                color: settingFormData?.[
                  ".downloadbox-section .downloadbox .btn"
                ]?.["color"]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData?.[
                      ".downloadbox-section .downloadbox .btn"
                      ]?.["color"],
                  })
                  : "",
              },
            };
            if (isBackgroundColor) {
              newData[".downloadbox-section"] = {
                ...newData?.[".downloadbox-section"],
                "background-color": settingFormData[".downloadbox-section"]?.[
                  "background-color"
                ]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".downloadbox-section"]?.[
                      "background-color"
                      ],
                  })
                  : "",
              };
            }
            if (boxSection) {
              newData[".downloadbox-section.bg-image::before"] = {
                ...newData[".downloadbox-section.bg-image::before"],
                "border-radius": `${settingFormData?.[".downloadbox-section"]?.[
                  "border-radius"
                ]?.replace("rem", "")}rem`,
              };
            }
          }
          const keysToRemove = ["image"];
          function removeKeys(obj, keys) {
            for (const key in obj) {
              if (typeof obj[key] === "object") {
                removeKeys(obj[key], keys);
              } else if (keys.includes(key)) {
                delete obj[key];
              }
            }
          }
          removeKeys(newData, keysToRemove);
          newData = {
            theme,
            style: newData,
            id: id,
          };
        }

        const { data } = await putUpdateDownloadSendReports(newData);
        if (data.status === 200) {
          if (isClose) {
            emptyDataReportDownload();
            setBackImageToggle(false);
            setBoxSection(false);
            setBackImageToggle(false);
            OpenModalCommonFunc(
              Cases.SETTING_REPORT_DOWN_PARENT,
              setAllPopupState,
              false
            );
          }
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  /**
   * create new about us
   */
  const hanldenewCreate = () => {
    setFormData({
      title: "",
      aboutUs: "",
      isTitleShow: true,
      order: 1,
      subTitle: "",
      theme: 1,
      buttonText: "",
      buttonLink: "",
      imageAlt: "",
    });
    setIsEdit(false);
  };

  /**
   * clear data
   */
  const emptyDataReportDownload = () => {
    setIsBackgroundColor(false);
    setBoxSection(false);
    setIsParent(false);
    setBoxSection(false);
    setBackImageToggle(false);
    // setId("");
    setIsEdit(false);
    setChildId("");
    setLoaderShow(false);
    setFormData({
      title: "",
      aboutUs: "",
      order: 1,
      subTitle: "",
      theme: 1,
      images: "",
      isTitleShow: true,
      buttonText: "",
      buttonLink: "",
      imageAlt: "",
      otherData: [
        {
          id: randomStr(2),
          image: "",
          title: "",
          imageAlt: "",
          description: "",
        },
      ],
    });
    setSettingFormData({});
    // setId("");
    setIsEdit(false);
    setFormDataParent({
      name: "",
      wpNumber: null,
      email: "",
      contentMapId: "",
      style: {
        ".downloadbox-section": {
          padding: "50px 0",
          "background-color": "rgb(249 249 249 / 100)",
        },
        ".downloadbox-section .section-title-area": {
          "margin-bottom": "50px",
        },
        ".downloadbox-section .section-title-area .section-subtitle": {
          "font-size": "16px",
          "font-weight": "600",
          color: "rgb(255 73 124 / 100)",
          "background-color": "rgb(255 73 124 / 0.2)",
          padding: "5px 20px",
          p1: "5px",
          p2: "20px",
          "border-radius": "15px",
          display: "inline-block",
          "margin-bottom": "15px",
        },
        ".downloadbox-section .section-title-area .section-title": {
          "font-size": "44px",
          "font-weight": "600",
          color: "rgb(0 0 0 / 100)",
        },
        ".downloadbox-section .downloadbox": {
          "background-color": "rgba(255, 255, 255, 1)",
          padding: "40px 40px",
          p1: "40px",
          p2: "40px",
          "border-radius": "15px",
          border: "1px solid rgba(249, 249, 249, 1)",
          borderPx: "1px",
          borderThik: "solid",
          borderColor: "rgba(249, 249, 249, 1)",
          "border-top": "3px solid rgb(255 73 124 / 100)",
          borderTPx: "3px",
          borderTThik: "solid",
          borderTColor: "rgb(255 73 124 / 100)",
          "box-shadow": "5px 5px 15px rgba(0,0,0,0.09)",
          bs1: "5px",
          bs2: "5px",
          bs3: "15px",
          shedowColor: "rgb(0 0 0 / 0.09)",
        },
        ".downloadbox-section .downloadbox .form-control": {
          width: "100%",
          "margin-bottom": "10px",
          "background-color": "rgba(238, 238, 238, 1)",
          border: "2px solid rgba(238, 238, 238, 1)",
          borderPx: "2px",
          borderThik: "solid",
          borderColor: "rgba(238, 238, 238, 1)",
          "border-radius": "0",
          "font-size": "16px",
          appearance: "auto",
          outline: "none",
        },
        ".downloadbox-section .downloadbox .btn": {
          color: "rgba(255, 255, 255, 1)",
          "background-color": "rgb(255 73 124 / 100)",
        },
      },
    });
    forceUpdate({});
  };

  const handleAlignAndCloneSection = ({ isClone = false }) => {
    if (isClone) {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          cloneModal: true,
        };
      });
      setCloneFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          pageConfigDetailsLabel: pageConfigDetails[0]?.label,
          contentDetailName: contentDetail.name,
        };
      });
    } else {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          alignModal: true,
        };
      });
      setAlignFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          label: pageConfigDetails[0]?.label,
        };
      });
    }
  };
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody
            className="support-ticket-font box-border-div"
            style={{ padding: "20px" }}
          >
            <CardBuilderHeaderSection
              addBtnTitle={pageConfigDetails[0]?.label}
              name={pageConfigDetails[0]?.label}
              isAdd={!downloadSendReportDetail && true}
              mainEditSection={true}
              ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
              pageId={pageConfigDetails[0]?.pageId}
              openModal={() => {
                setCollId(contentMapId);
                setSectionPageName(modalsName.REPORT_DOWN_PARENT);
                setIsParent(true);
                OpenModalCommonFunc(Cases.REPORT_DOWN_PARENT, setAllPopupState);
              }}
              isCloneSection={true}
              isAlignSection={true}
              handleAlignAndCloneSection={handleAlignAndCloneSection}
            />
            <Row>
              {downloadSendReportDetail && (
                <Col xl="12 xl-50 box-col-6" md="6">
                  <Card className="ecommerce-widget">
                    <CardBody
                      className="support-ticket-font mb-0"
                      style={{ padding: "20px" }}
                    >
                      <div className="col-12">
                        <CardBuilderHeaderSection
                          name={downloadSendReportDetail?.name}
                          checked={downloadSendReportDetail?.isActive}
                          switchToggle={true}
                          id={downloadSendReportDetail?.reportDownloadSentId}
                          handleChange={handleChangeStatus}
                        />
                        {/* <OpenPopupBtn
                          openPopup={() => {
                            setCollId(contentMapId);
                            getAboutUsList({
                              parentId:
                                downloadSendReportDetail.reportDownloadSentId,
                              sectionTitle: downloadSendReportDetail?.title,
                            });
                          }}
                          name={`Add or View ${downloadSendReportDetail?.title}`}
                        /> */}
                      </div>
                      <div className="d-flex justify-content-end ">
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            setCollId(contentMapId);
                            handleEdit(
                              downloadSendReportDetail.reportDownloadSentId,
                              true
                            );
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            handleDelete(
                              downloadSendReportDetail.reportDownloadSentId,
                              true
                            )
                          }
                        >
                          <Trash />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            handleChangeSettings(
                              downloadSendReportDetail.reportDownloadSentId
                            );
                          }}
                        >
                          <Settings />
                        </IconButton>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )}
              <DeleteSection
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
              />
              {/* <OpenPopupBtn
                openPopup={() =>
                  OpenModalCommonFunc(Cases.REPORT_DOWN, setAllPopupState)
                }
                name={btnName.REPORT_DOWN}
              /> */}
            </Row>
          </CardBody>
        </Card>
      </Col>

      {/* about us parent popup  */}
      <CommonPopup
        open={allPopupState.reportDownloadSentParentPopup}
        close={() => {
          OpenModalCommonFunc(
            Cases.REPORT_DOWN_PARENT,
            setAllPopupState,
            false
          );
          setIsParent(false);
        }}
        modalName={
          sectionPageName ? sectionPageName : modalsName.REPORT_DOWN_PARENT
        }
        modalCase={Cases.REPORT_DOWN_PARENT}
        handleSubmit={handleSubmitWithValidate}
        show={false}
        edit={false}
        emptyData={emptyDataReportDownload}
        inputData={formDataParent}
        validationForm={"parentForm"}
        content={
          <ReportDownloadSentParentPopup
            emptyData={emptyDataReportDownload}
            simpleValidator={parentValidator}
          />
        }
      />

      <CommonPopup
        open={allPopupState.reportDownloadSentPopup}
        close={() => {
          OpenModalCommonFunc(Cases.REPORT_DOWN, setAllPopupState, false);
          setIsParent(false);
        }}
        // apiCall={getAboutUsList}
        modalName={sectionPageName ? sectionPageName : modalsName.REPORT_DOWN}
        modalCase={Cases.REPORT_DOWN}
        handleSubmit={handleSubmitWithValidate}
        emptyData={emptyDataReportDownload}
        inputData={fromData}
        edit={false}
        validationForm={"childForm"}
        oldTitle={titleUpdateKey.isAboutUs}
        label={titleUpdateKey.REPORT_DOWN}
        getData={getData}
        content={
          <ReportDownloadSentPopup
            getAboutUsList={getAboutUsList}
            handleChangeStatus={handleChangeStatus}
            handleSubmit={handleSubmitWithValidate}
            getData={getAboutUsList}
            handleEdit={handleEdit}
            imageUpload={imageUpload}
            emptyData={emptyDataReportDownload}
            simpleValidator={childValidator}
            webMasterDetail={webMasterDetail}
          />
        }
      />

      <CommonPopup
        open={allPopupState.reportDownloadSentSettingPopup}
        close={() =>
          OpenModalCommonFunc(
            Cases.SETTING_REPORT_DOWN_PARENT,
            setAllPopupState,
            false
          )
        }
        modalName={
          sectionPageName
            ? sectionPageName
            : modalsName.SETTING_REPORT_DOWN_PARENT
        }
        modalCase={Cases.SETTING_REPORT_DOWN_PARENT}
        handleSubmit={handleAboutUsSubmitSetting}
        emptyData={emptyDataReportDownload}
        inputData={fromData}
        edit={false}
        content={
          <ReportDownloadSentSettingParent
            imageUpload={backgroundImageUpload}
            handleSubmitSetting={handleAboutUsSubmitSetting}
            handleChangeSettings={handleChangeSettings}
          />
        }
      />
    </>
  );
};

export default ReportDownloadSent;
